import template from './ovalTag.html';

export default {
  template,
  bindings: {
    type: '<',
    content: '<',
  },
};
